import React, { useEffect, useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { useLanguage } from '../../context/LanguageContext';

const Counter = ({ value, duration = 1.5, suffix = "" }) => {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const inView = useInView(ref, { once: true });

  useEffect(() => {
    if (!inView) return;
    
    const parsedValue = parseInt(value.toString().replace(/[^0-9]/g, ""), 10) || 0;
    let startTimestamp = null;

    const step = (timestamp) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = Math.min((timestamp - startTimestamp) / (duration * 1000), 1);
      const easeProgress = progress * (2 - progress);
      setCount(Math.floor(easeProgress * parsedValue));
      
      if (progress < 1) {
        window.requestAnimationFrame(step);
      } else {
        setCount(parsedValue);
      }
    };

    window.requestAnimationFrame(step);
  }, [inView, value, duration]);

  return (
    <span ref={ref} className="stat-counter-value">
      {count.toLocaleString()}
      {suffix}
    </span>
  );
};

export const StatsBlock = () => {
  const { t } = useLanguage();

  const statsItems = [
    { key: 'onlineUsers', value: 1420, suffix: ' чел', icon: 'fa-users' },
    { key: 'reviews', value: 3500, suffix: '+', icon: 'fa-thumbs-up' },
    { key: 'community', value: 12800, suffix: '+', icon: 'fa-comments' },
    { key: 'invites', value: 14230000, suffix: '+', icon: 'fa-envelope-open-text' },
    { key: 'messages', value: 84900000, suffix: '+', icon: 'fa-paper-plane' }
  ];

  return (
    <section className="stats-section bg-cyber-gradient" id="stats">
      <div className="stats-container">
        <div className="section-header text-center">
          <h2 className="section-title text-white">{t('stats.title')}</h2>
          <span className="section-line line-white" />
        </div>

        <div className="custom-community-grid">
          {statsItems.map((stat, index) => (
            <motion.div 
              key={stat.key}
              className="stat-card community-card-wrapper"
              initial={{ opacity: 0, y: 15 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.05 }}
            >
              <div className="stat-icon-wrapper">
                <i className={`fas ${stat.icon} stat-fa-icon`}></i>
              </div>
              <h3 className="stat-number">
                <Counter value={stat.value} suffix={stat.suffix} />
              </h3>
              <p className="stat-label">{t(`stats.${stat.key}`)}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsBlock;